const commonOptimization = {
  commonUrl(){
    // console.log(window.location.href,window.location.host,'ljy');
    let url = window.location.href
    let str = ''
    if(url.indexOf('//jdhd.tj9.')>-1){
      str = `https://mini-app-static.jd.com/apps/mpshare/index.html?category=jump&des=jdmp&vapptype=1&appId=22AF00009B3D46B8DECBC457090B3560&path=`; // 正式
    }else{
      str = `https://mini-app-static.jd.com/apps/mpshare/index.html?category=jump&des=jdmp&vapptype=2&appId=22AF00009B3D46B8DECBC457090B3560&path=`; // 体验版
    }
    return str
  },
  jingdouTotal(row) {
    if (row.quantityTotal && row.prizeCount && Number(row.prizeCount) * Number(row.price) > row.quantityTotal) {
      return "";
    } else {
      return row.prizeCount;
    }
  },
  // days为时间间隔的天数，+代表今日往后计算；-代表今日往前计算。minValue为当前时间几分钟后 默认为10分钟
  getDate(days,minValue = 0) {
      //定义今日标准时间;
    
      let d = new Date();
      // 当前时间
      let currentTime = getYMDHMS(d.getTime() + minValue * 60 * 1000);
      let nowYear = d.getFullYear().toString();//今年
      let nowMonth = timeAdd0((d.getMonth() + 1).toString());//当月
      let nowDay = timeAdd0(d.getDate().toString());//当日
      let now = nowYear + "-" + nowMonth + "-" + nowDay;//今日标准时间; 2020-09-02

      //日期计算;
      let startDate = new Date(Date.parse(now.replace(/-/g, '/'))); //将开始时间由字符串格式转换为日期格式
      let value = startDate.getTime();  //将开始时间转为毫秒
      value += days * (24 * 3600 * 1000); //将天数转换成毫秒后与开始时间相加得到结束时间的毫秒数
      let d2 = new Date(value);    //将得到的毫秒数转换为日期
      let nowYear2 = d2.getFullYear().toString();//今年
      let nowMonth2 = timeAdd0((d2.getMonth() + 1).toString());//当月
      let nowDay2 = timeAdd0(d2.getDate().toString());//当日
      let endDate = nowYear2 + "-" + nowMonth2 + "-" + nowDay2;

      let endDateTime = ''
      let pastTimestamp = new Date(this.$store.getters.loginUserInfo.expiredIn).getTime()
      let activTimestamp = new Date(endDate + currentTime.substring(10,currentTime.length)).getTime()
      if(pastTimestamp < activTimestamp) {
        endDateTime = this.$store.getters.loginUserInfo.expiredIn
      }else{
        endDateTime = endDate + currentTime.substring(10,currentTime.length)
      }
      return [currentTime,endDateTime];
  },
  // days为时间间隔的天数，+代表今日往后计算；-代表今日往前计算。minValue为当前时间几分钟后 默认为10分钟
  getActDate(days,actime,minValue = 10) {
      //定义今日标准时间;
    
      let d = new Date(actime);
      // 当前时间
      let currentTime = getYMDHMS(d.getTime() + minValue * 60 * 1000);
      let nowYear = d.getFullYear().toString();//今年
      let nowMonth = timeAdd0((d.getMonth() + 1).toString());//当月
      let nowDay = timeAdd0(d.getDate().toString());//当日
      let now = nowYear + "-" + nowMonth + "-" + nowDay;//今日标准时间; 2020-09-02

      //日期计算;
      let startDate = new Date(Date.parse(now.replace(/-/g, '/'))); //将开始时间由字符串格式转换为日期格式
      let value = startDate.getTime();  //将开始时间转为毫秒
      value += days * (24 * 3600 * 1000); //将天数转换成毫秒后与开始时间相加得到结束时间的毫秒数
      let d2 = new Date(value);    //将得到的毫秒数转换为日期
      let nowYear2 = d2.getFullYear().toString();//今年
      let nowMonth2 = timeAdd0((d2.getMonth() + 1).toString());//当月
      let nowDay2 = timeAdd0(d2.getDate().toString());//当日
      let endDate = nowYear2 + "-" + nowMonth2 + "-" + nowDay2;

      let endDateTime = endDate + currentTime.substring(10,currentTime.length)
      return [currentTime,endDateTime];
  },
  
  toChinesNum(num) {
    let arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
    let arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿');//可继续追加更高位转换值
    if (!num || isNaN(num)) {
      return "零";
    }
    let english = num.toString().split("");
    let result = "";
    for (let i = 0; i < english.length; i++) {
      let des_i = english.length - 1 - i;//倒序排列设值
      result = arr2[i] + result;
      let arr1_index = english[des_i];
      result = arr1[arr1_index] + result;
    }
    //将【零千、零百】换成【零】 【十零】换成【十】
    result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
    //合并中间多个零为一个零
    result = result.replace(/零+/g, '零');
    //将【零亿】换成【亿】【零万】换成【万】
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
    //将【亿万】换成【亿】
    result = result.replace(/亿万/g, '亿');
    //移除末尾的零
    result = result.replace(/零+$/, '');
    //将【零一十】换成【零十】
    //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
    //将【一十】换成【十】
    result = result.replace(/^一十/g, '十');
    return result;
  }
}
 //补齐十位数;
function timeAdd0(str) {
    if (str.length <= 1) {
        str = '0' + str;
    }
    return str
}
// 时间格式化
function getYMDHMS (timestamp) {
  let time = new Date(timestamp)
  let year = time.getFullYear()
  const month = (time.getMonth() + 1).toString().padStart(2, '0')
  const date = (time.getDate()).toString().padStart(2, '0')
  const hours = (time.getHours()).toString().padStart(2, '0')
  const minute = (time.getMinutes()).toString().padStart(2, '0')
  const second = (time.getSeconds()).toString().padStart(2, '0')

  return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
}

export default commonOptimization